import React from "react"

/**
 * Sentinel for card-list infinite scroll. Pair with useInfinitePagination.
 * Table listings should keep numbered Pagination instead.
 */
const InfiniteListSentinel = ({
  sentinelRef,
  hasMore = false,
  className = "infinite-list-sentinel",
}) => {
  if (!hasMore) return null

  return <div ref={sentinelRef} className={className} aria-hidden="true" />
}

export default InfiniteListSentinel
